<template>
	<div :class="['m_' + currentRoute, 'mobile_wrap', { sub_page, m_terms }]">
		<Header></Header>
		<router-view></router-view>
		<FooterM></FooterM>
	</div>
</template>

<script>
import Header from '@/components/Layout/Header.m';
import FooterM from '@/components/Layout/Footer.m';
export default {
	name: 'Layout.m',
	components: {
		Header,
		FooterM,
	},
	props: {
		sub_page: {
			default: false,
			type: Boolean,
		},
		m_terms: {
			default: false,
			type: Boolean,
		},
	},
	computed: {
		currentRoute() {
			return this.$route.name;
		},
	},
};
</script>
